import Carousel3D from './Carousel3D.vue';

export { Carousel3D };
export default Carousel3D;
